import React from 'react'
import { Helmet } from 'react-helmet'

import { Navbar, Footer, Landing, About, Experience, Skills,Education, Contacts, Projects, Achievement } from '../../components'
import { headerData } from '../../data/headerData'

function Main() {
    return (
        <div> 
            <Helmet>
                <title>{headerData.name} - Porfolio</title>
            </Helmet>

            <Navbar />        
            <Landing />
            <About />
            <Experience />
            <Education />
            <Skills />
            <Projects />
            <Achievement />
            
            <Contacts />
            <Footer />
        </div>
    )
}

export default Main
